
import {
  Box,
  Grid,
  Checkbox,
  CircularProgress,
  List,
  Stack,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
  useTheme
} from "@mui/material";
import { useNavigate } from "react-router";
import React, { useEffect, useState } from "react";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import Certifications from "../components/Cv/Certifications";
import Courses from "../components/Cv/Courses";
import CvQualityIndex from "../components/CvIndex";
import EditIcon from '@mui/icons-material/Edit';
import Education from "../components/Cv/Education";
import Expertise from "../components/Cv/AreasOfExpertise";
import GitRepo from "../components/Cv/GitRepo";
import IconButton from '@mui/material/IconButton';
import Languages from "../components/Cv/Languages";
import MenuItem from '@mui/material/MenuItem';
import Methods from "../components/Cv/Methods";
import Portfolio from "../components/Cv/Portfolio";
import Projects from "../components/Cv/Projects";
import QaSkills from "../components/Cv/QaSkills";
import Roles from "../components/Cv/MainRoles";
import Select from '@mui/material/Select';
import SoftSkills from "../components/Cv/SoftSkills";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import Summary from "../components/Cv/Summary";
import TechSkills from '../components/Cv/TechSkills';
import TokenExpiredModal from "../components/TokenExpiredModal";
import WorkExperiences from "../components/Cv/WorkExperiences";
import api from "../api/axiosInstance";
import { primaryRoles } from "config";
import { selectCandidateCvByCvId } from "../lib/cvsSlice";
import { toast } from 'react-toastify';
import { useEditCvRoleMutation } from "../lib/cvsSlice";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import WorkIcon from "@mui/icons-material/Work";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import StarIcon from "@mui/icons-material/Star";
import CvBuiderMenu from "../components/CvBuilderMenu";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import BuildIcon from "@mui/icons-material/Build";
import CloudIcon from "@mui/icons-material/Cloud";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import DescriptionIcon from "@mui/icons-material/Description";
import FolderIcon from "@mui/icons-material/Folder";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import HomeIcon from "@mui/icons-material/Home";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ScheduleIcon from "@mui/icons-material/Schedule";
import SecurityIcon from "@mui/icons-material/Security";
import CVHeader from '../components/CvBuilderMenu/CVHeader'

const SIDEBAR_WIDTH = 274;
const HEADER_HEIGHT = 65;

const navigationItems = [
  { text: "Home", icon: HomeIcon, path: "/" },
  { text: "CV Builder", icon: BuildIcon, path: "/", active: true },
  { text: "CVs", icon: DescriptionIcon, path: "/" },
  { text: "Files & Media", icon: CloudIcon, path: "/native-coders-files" },
];


const Sidebar = ({ currentPath }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Box
      sx={{
        width: SIDEBAR_WIDTH,
        minWidth: SIDEBAR_WIDTH,
        height: `calc(100vh - ${HEADER_HEIGHT}px)`,
        backgroundColor: theme.palette.background.paper,
        borderRight: 'none',
        boxShadow: '0px 2px 1px -1px #00000033, 0px 1px 1px 0px #00000024, 0px 1px 3px 0px #0000001F',
        overflowY: 'auto',
        position: 'fixed',
        left: 0,
        top: `${HEADER_HEIGHT}px`,
        zIndex: 1000,
      }}
    >
      <List sx={{ padding: '8px' }}>
        {navigationItems.map((item) => (
          <ListItem
            key={item.text}
            onClick={() => handleNavigation(item.path)}
            sx={{
              cursor: 'pointer',
              width: '258px',
              height: '40px',
              padding: '8px 16px',
              margin: 0,
              marginBottom: '8px',
              borderRadius: '4px',
              gap: '8px',
              backgroundColor: item.active ? theme.palette.grey[400] : 'transparent',
              color: item.active ? '#000000' : theme.palette.grey[500],
              '&:hover': {
                backgroundColor: theme.palette.grey[400],
                color: '#000000',
                '& .MuiListItemIcon-root .MuiSvgIcon-root': {
                  color: '#000000',
                },
              },
              '& .MuiListItemIcon-root .MuiSvgIcon-root': {
                color: item.active ? theme.palette.grey[500] : theme.palette.grey[500],
              },
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <ListItemIcon sx={{
              minWidth: '24px',
              width: '24px',
              height: '24px',
              marginRight: '8px'
            }}>
              <item.icon
                sx={{
                  fontSize: '24px',
                  width: '24px',
                  height: '24px',
                }}
              />
            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

const CvDetails = ({ mainroles }) => {
  let { id } = useParams();
  const theme = useTheme();
  const cv = useSelector((state) => selectCandidateCvByCvId(state, id));

  const [loading, setLoading] = useState(true);
  const [candidate, setCandidate] = useState();
  const [cvDetails, setCvDetails] = useState(cv);
  const [checked, setChecked] = useState(false);
  const [tokenExpiredModalOpen, setTokenExpiredModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedRole, setSelectedRole] = useState(mainroles);

  const [editCvRole, { isError, error }] = useEditCvRoleMutation();

  const items = [];
  const itemDetails = [];

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  useEffect(() => {
    const savedChecked = localStorage.getItem('isChecked');
    if (savedChecked !== null) {
      setChecked(savedChecked === 'true');
    }
  }, []);

  const fetchCvAndCandidate = async (id) => {
    try {
      // FIX: Use the correct endpoint that exists in your backend
      // Your backend has: CVRoutes.get('/:cvId', getCv);
      // So the correct endpoint is /cv/{id}, not /cv/getsinglecv/{id}
      const { data: cvResponse } = await api.get(`/cv/${id}`);
      const { data: candidateResponse } = await api.get(`/users/`);

      setCandidate(candidateResponse);
      setCvDetails(cvResponse);
      setLoading(false);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 401) {
        setTokenExpiredModalOpen(true);
      }
      setLoading(true);
    }
  };

  useEffect(() => {
    fetchCvAndCandidate(id);
    const refreshInterval = setInterval(() => {
      fetchCvAndCandidate(id);
    }, 1000);
    return () => {
      clearInterval(refreshInterval);
    };
  }, [id, mainroles]);


  const handleCheckboxChange = async (event) => {
    const imageValue = event.target.checked;
    setChecked(imageValue);

    try {
      // Use your custom api instance
      const response = await api.post(`/users/updateImageState/${cvDetails?.owner}`, {
        imageValue,
      });

      setChecked(response.data?.imageValue);
    } catch (error) {
      console.error(error);
    }
    localStorage.setItem('isChecked', imageValue.toString());
  };

  const handleEditClick = () => {
    setSelectedRole(cvDetails.mainRole);
    setEditMode(true);
  };

  const handleSaveClick = async () => {
    try {
      const cvId = id;
      await editCvRole({ cvId, mainroles: selectedRole });
      setEditMode(false);
    } catch (error) {
      toast.error(`An error occurred while updating mainrole: ${error}`);
    }
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  useEffect(() => {
    fetchCvAndCandidate(id)
  }, [id]);

  if (cvDetails === undefined) {
    return null;
  }

  // Rest of your component logic remains the same...
  /*   Object.keys(cvDetails).forEach((item) => {
      if (Array.isArray(cvDetails[item])) {
        items.push(
          <Grid item xs={12} md={6} key={item}>
            <Stack direction="row" alignItems="center" gap={1} sx={{ ml: "25px" }}>
              <StarBorderIcon color="primary" />
              <Typography component="div" sx={{ fontSize: "15px", p: 2 }}>
                {capitalizeFirstLetter(item) + " (" + cvDetails[item].length + ")"}
              </Typography>
            </Stack>
          </Grid>
        );
      }
  
      const hasKeyAssignments = cvDetails.projects.some(proj => proj.keyAssignments === true);
      const projectsWithKeyAssignments = cvDetails.projects
        .filter(proj => proj.keyAssignments === true)
        .slice(0, 2);
  
      // Your existing switch logic for different roles...
      if (
        cvDetails.mainRole === "Software Developer" ||
        cvDetails.mainRole === "Full-stack Developer" ||
        cvDetails.mainRole === "Front-end Developer" ||
        cvDetails.mainRole === "Back-end Developer"
      ) {
        switch (item) {
          case "summary":
            itemDetails.push(<Summary key={0} summary={cvDetails[item]} cvId={id} />);
            if (hasKeyAssignments && projectsWithKeyAssignments.length > 0) {
              itemDetails.push(<Projects key={1} projs={projectsWithKeyAssignments} cvId={id} label="Key Assignments" />);
            }
            break;
          case "portfolio":
            itemDetails.push(<Portfolio key={1} portfolio={cvDetails[item]} cvId={id} />);
            break;
          case "certifications":
            itemDetails.push(<Certifications key={2} certs={cvDetails[item]} cvId={id} />);
            break;
          case "projects":
            itemDetails.push(<Projects key={4} projs={cvDetails[item]} cvId={id} />);
            break;
          case "courses":
            itemDetails.push(<Courses key={5} courses={cvDetails[item]} cvId={id} />);
            break;
          case "languages":
            itemDetails.push(<Languages key={6} langs={cvDetails[item]} cvId={id} />);
            break;
          case "techSkills":
            itemDetails.push(<TechSkills key={8} techSkills={cvDetails[item]} cvId={id} />);
            itemDetails.push(<SoftSkills key={8.5} softSkills={cvDetails?.softSkills || []} cvId={id} />);
            break;
          case "educations":
            itemDetails.push(<Education key={8} educations={cvDetails[item]} cvId={id} />);
            break;
          case "methods":
            itemDetails.push(<Methods key={8} method={cvDetails[item]} cvId={id} />);
            break;
          case "gitRepo":
            itemDetails.push(<GitRepo key={9} gitRepo={cvDetails[item]} cvId={id} />);
            break;
          case "experiences":
            itemDetails.push(<WorkExperiences key={8} experiences={cvDetails[item]} cvId={id} />);
            break;
          case "expertise":
            itemDetails.push(<Expertise key={11} expertise={cvDetails[item]} cvId={id} label="Areas of Expertise" />);
            break;
          case "roles":
            itemDetails.push(<Roles key={11} roles={cvDetails[item]} cvId={id} />);
            break;
          default:
        }
      } else if (
        cvDetails.mainRole === "Software Tester / QA Engineer" ||
        cvDetails.mainRole === "QA Lead / Test Manager"
      ) {
        // Your QA role logic...
        switch (item) {
          case "summary":
            itemDetails.push(<Summary key={0} summary={cvDetails[item]} cvId={id} />);
            if (hasKeyAssignments && projectsWithKeyAssignments.length > 0) {
              itemDetails.push(<Projects key={1} projs={projectsWithKeyAssignments} cvId={id} label="Key Assignments" />);
            }
            break;
          case "projects":
            itemDetails.push(<Projects key={1} projs={cvDetails[item]} cvId={id} />);
            break;
          case "certifications":
            itemDetails.push(<Certifications key={2} certs={cvDetails[item]} cvId={id} />);
            break;
          case "qaSkill":
            itemDetails.push(<QaSkills key={3} qaSkill={cvDetails[item]} cvId={id} />);
            break;
          case "educations":
            itemDetails.push(<Education key={4} educations={cvDetails[item]} cvId={id} />);
            break;
          case "experiences":
            itemDetails.push(<WorkExperiences key={5} experiences={cvDetails[item]} cvId={id} />);
            break;
          case "courses":
            itemDetails.push(<Courses key={8} courses={cvDetails[item]} cvId={id} />);
            break;
          case "methods":
            itemDetails.push(<Methods key={7} method={cvDetails[item]} cvId={id} />);
            break;
          case "languages":
            itemDetails.push(<Languages key={6} langs={cvDetails[item]} cvId={id} />);
            break;
          case "expertise":
            itemDetails.push(<Expertise key={9} expertise={cvDetails[item]} cvId={id} label="Areas of Expertise" />);
            break;
          case "roles":
            itemDetails.push(<Roles key={10} roles={cvDetails[item]} cvId={id} />);
            break;
          default:
        }
      } else {
        // Your default role logic...
        switch (item) {
          case "summary":
            itemDetails.push(<Summary key={0} summary={cvDetails[item]} cvId={id} />);
            if (hasKeyAssignments && projectsWithKeyAssignments.length > 0) {
              itemDetails.push(<Projects key={1} projs={projectsWithKeyAssignments} cvId={id} label="Key Assignments" />);
            }
            break;
          case "portfolio":
            itemDetails.push(<Portfolio key={1} portfolio={cvDetails[item]} cvId={id} />);
            break;
          case "certifications":
            itemDetails.push(<Certifications key={2} certs={cvDetails[item]} cvId={id} />);
            break;
          case "projects":
            itemDetails.push(<Projects key={4} projs={cvDetails[item]} cvId={id} />);
            break;
          case "courses":
            itemDetails.push(<Courses key={2} courses={cvDetails[item]} cvId={id} />);
            break;
          case "languages":
            itemDetails.push(<Languages key={3} langs={cvDetails[item]} cvId={id} />);
            break;
          case "methods":
            itemDetails.push(<Methods key={6} method={cvDetails[item]} cvId={id} />);
            break;
          case "experiences":
            itemDetails.push(<WorkExperiences key={10} experiences={cvDetails[item]} cvId={id} />);
            break;
          case "educations":
            itemDetails.push(<Education key={8} educations={cvDetails[item]} cvId={id} />);
            break;
          case "expertise":
            itemDetails.push(<Expertise key={11} expertise={cvDetails[item]} cvId={id} label="Areas of Expertise" />);
            break;
          case "roles":
            itemDetails.push(<Roles key={10} roles={cvDetails[item]} cvId={id} />);
            break;
          default:
        }
      }
    }); */

  itemDetails.sort(function (a, b) {
    var keyA = a.key, keyB = b.key;
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    return 0;
  });

  const rolesInProject = cvDetails.projects.map((project) => project.roleInProject).flat();
  const {
    _id: cvId, // Rename _id to cvId for clarity
    summary,
    projects,
    experiences,
    portfolio,
    gitRepo,
    expertise,
    roles,
    certifications,
    courses,
    languages,
    methods,
    educations
  } = cvDetails;
  const steps = [
    {
      label: "Summary",
      helperText: "Professional Overview",
      icon: <DescriptionIcon />,
      content: <Summary summary={summary || "No summary provided."} cvId={cvId} />,
    },
    {
      label: "Assignments and Project",
      helperText: "Key Contributions and Achievements",
      icon: <WorkIcon />,
      content: <div>
        <Projects key={4} projs={projects} cvId={cvId} />
      </div>
    },
    {
      label: "Work Experience",
      helperText: "Employment History",
      icon: <BusinessCenterIcon />,
      content: <WorkExperiences experiences={experiences} cvId={cvId} />,
    },
    {
      label: "Proffesional Links",
      helperText: "Work Samples and Projects",
      icon: <FolderIcon />,
      content: <Portfolio portfolio={portfolio} cvId={cvId} />
    },
    {
      label: "Area of expertise",
      helperText: "Key skills and Specializations",
      icon: <StarIcon />,
      content: <Expertise expertise={expertise} cvId={cvId} label="Areas of Expertise" />
    },
    {
      label: "Highlighted Roles",
      helperText: "Notable Work Experiences",
      icon: <StarIcon />,
      content: <Roles roles={roles} cvId={cvId} />
    },
    {
      label: "Licenses & Certifications",
      helperText: "Credentials and Qualifications",
      icon: <StarIcon />,
      content: <Certifications certs={certifications} cvId={cvId} />
    },
    {
      label: "Courses",
      helperText: "Training and Professional Development",
      icon: <StarIcon />,
      content: <Courses courses={courses} cvId={cvId} />
    },
    {
      label: "Languages",
      helperText: "Language Proficiency",
      icon: <StarIcon />,
      content: <Languages langs={languages} cvId={cvId} />
    },
    {
      label: "Methods",
      helperText: "Techniques and Methodologies",
      icon: <StarIcon />,
      content: <Methods method={methods} cvId={cvId} />
    },
    {
      label: "Education",
      helperText: "Academic Background",
      icon: <StarIcon />,
      content: <Education educations={educations} cvId={cvId} />
    },
  ];

  return (
    <div
    //style={{
    //minHeight: "100vh", // Match viewport height exactly
    //minWidth: "100vw", // Match viewport width exactly
    //backgroundColor: "#EAE7E6", // Background color for entire viewport
    //overflow: "hidden", // Prevent page-level scrollbars
    //}}
    >
      <TokenExpiredModal
        isOpen={tokenExpiredModalOpen}
        onClose={() => setTokenExpiredModalOpen(false)}
      />

      {loading && (
        <Paper elevation={1} sx={{ minHeight: "100vh", justifyContent: "center", alignItems: "center", p: 1 }}>
          <CircularProgress />
        </Paper>
      )}

      {/* Sidebar - fixed positioning */}
      <Sidebar currentPath="" />

      {/* main - content */}
      <div
        style={{
          position: 'fixed',
          top: '65px',
          left: '258px',
          width: '85vw',
          height: '95vh',
          overflow: 'auto',
          padding: '16px 24px',
          boxSizing: 'border-box',
          background: '#EAE7E6'
        }}
      >
        <CVHeader menuItems={<div>
          <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
            {editMode ? (
              <Select value={selectedRole} onChange={handleRoleChange}>
                {primaryRoles.map((role) => (
                  <MenuItem key={role} value={role}>
                    {role}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <h4>{cvDetails.mainRole}</h4>
            )}
            {editMode ? (
              <IconButton onClick={handleSaveClick} color="primary" sx={{ fontSize: '17px' }}>
                Save
              </IconButton>
            ) : (
              <IconButton onClick={handleEditClick} color="primary">
                <EditIcon sx={{ fontSize: 17 }} />
              </IconButton>
            )}
          </Grid>
          <Grid item xs={8}>
            {rolesInProject && rolesInProject.length > 0 && (
              <Typography variant="caption" components="block">
                Other roles: {rolesInProject.join(", ")}
              </Typography>
            )}
          </Grid>

        </div>} />
        <CvBuiderMenu steps={steps} />
      </div>

      {/* <Grid>
        <CvBuiderMenu steps={steps} />
      </Grid>
 */}
      {/*      {cvDetails && (
        <Paper elevation={3} sx={{ m: "20px", pl: "50px", pr: "15px", pt: "35px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <CvQualityIndex />
          <Grid container>
            <Grid item xs={12}>
              <Typography component="div" sx={{ justifyContent: "flex-start", textAlign: "left", fontSize: "40px", fontWeight: "bold" }}>
                {candidate?.firstname} {candidate?.lastname}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2} justifyContent="left" alignItems="left">
                <Grid container spacing={2} justifyContent="left" alignItems="left" paddingLeft="12px">
                  <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
                    {editMode ? (
                      <Select value={selectedRole} onChange={handleRoleChange}>
                        {primaryRoles.map((role) => (
                          <MenuItem key={role} value={role}>
                            {role}
                          </MenuItem>
                        ))}
                      </Select>
                    ) : (
                      <h4>{cvDetails.mainRole}</h4>
                    )}
                    {editMode ? (
                      <IconButton onClick={handleSaveClick} color="primary" sx={{ fontSize: '17px' }}>
                        Save
                      </IconButton>
                    ) : (
                      <IconButton onClick={handleEditClick} color="primary">
                        <EditIcon sx={{ fontSize: 17 }} />
                      </IconButton>
                    )}
                  </Grid>
                  <Grid item xs={8}>
                    {rolesInProject && rolesInProject.length > 0 && (
                      <Typography variant="caption" components="block">
                        Other roles: {rolesInProject.join(", ")}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={4} justifyContent="flex-end">
                    <AccountCircleOutlinedIcon color="primary" sx={{ fontSize: 90 }} />
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container spacing={1} justifyContent="right" alignItems="right">
                      <Grid item xs={4}>
                        <Checkbox checked={checked} onChange={handleCheckboxChange} color="primary" />
                        <Typography variant="caption">{checked ? 'Image excluded!' : 'Exclude image from pdf?'}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ paddingBottom: "40px" }}>
                    {itemDetails}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <div></div>
        </Paper>
      )} */}
    </div>
  );
};

export default CvDetails;